import type { Collection, IndexableType } from "dexie"

/**
 * The distinct keys of an index, in index order: `collection.uniqueKeys()`, safe on WebKit.
 *
 * iOS 26.x WebKit (measured on the iOS 26.5 simulator, 2026-10-15) fails a unique-direction cursor
 * ("nextunique" / "prevunique", which `uniqueKeys()` opens) on an index with no entries:
 * `UnknownError: Unable to open cursor`, and it then aborts the transaction the request was in. Every
 * empty index of `totodo` failed that way, every non-empty one worked, and iOS 27.0 does not have the
 * bug. A new account has no tags and no documents, so `orderBy("tags").uniqueKeys()` crashed the app
 * at first login ("Oops, something went wrong" from the tag picker's live query).
 *
 * So the index is first read with an ordinary cursor, one key: when it is empty no unique cursor is
 * opened at all (a failed request would already have aborted the transaction, so catching it and
 * retrying is not an option inside a live query).
 */
export async function uniqueIndexKeys(collection: Collection): Promise<IndexableType[]> {
  const first = await collection.clone().limit(1).keys()
  if (first.length === 0) return []
  return collection.uniqueKeys()
}
